//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseNumberInput from '~/components/base/base_number_input'
export default {
  name: 'LandingAboutSignUp',
  components: { BaseNumberInput },
  data () {
    return {
      mobile: null
    }
  },
  methods: {
    openTab () {
      const routeData = this.$router.resolve({ path: '/my/auth/register', query: { mobile: this.mobile } })
      window.open(routeData.href, '_blank')
    }
  }
}
